import { render } from "./account.vue?vue&type=template&id=6da8bf26"
import script from "./account.vue?vue&type=script&lang=js"
export * from "./account.vue?vue&type=script&lang=js"
script.render = render

export default script